var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCicd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EC672A",
    d: "M23.955 12.64 22.61 8.51 19.951.313c-.137-.42-.73-.42-.873 0l-2.66 8.19H7.58L4.92.313c-.137-.42-.73-.42-.873 0l-2.654 8.19L.047 12.64c-.121.375.01.79.332 1.024L12 22.107l11.621-8.443a.916.916 0 0 0 .334-1.024Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD3E2A",
    d: "m12.002 22.104 4.42-13.6h-8.84l4.42 13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC672A",
    d: "M11.998 22.104 7.58 8.504H1.393l10.605 13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6A420",
    d: "M1.389 8.508.045 12.64c-.121.375.01.789.332 1.023l11.621 8.443-10.61-13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD3E2A",
    d: "M1.39 8.507h6.194L4.918.317c-.137-.42-.73-.42-.873 0L1.39 8.508Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC672A",
    d: "m12.002 22.104 4.42-13.6h6.193l-10.613 13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6A420",
    d: "m22.61 8.508 1.345 4.13a.917.917 0 0 1-.332 1.024l-11.621 8.44L22.609 8.508Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD3E2A",
    d: "M22.613 8.507H16.42l2.66-8.19c.137-.42.73-.42.873 0l2.66 8.19Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v22.109H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCicd);
export default __webpack_public_path__ + "static/media/CICD.e100dc71f659f84a72e53d425deb0157.svg";
export { ForwardRef as ReactComponent };